<template>
  <div
    class="tw-font-title tw-font-black tw-uppercase"
    :class="viewInCart ? 'tw-text-xl' : 'tw-text-3xl'"
  >
    <span v-if="!viewInCart">${{ priceString }}</span>
    <span v-if="viewInCart">View Price In Cart</span>
    <span
      v-if="dsrp && !viewInCart"
      class="tw-text-xs tw-font-medium tw-px-2 tw-inline-block"
    >
      <sup>† DSRP</sup>
    </span>    
  </div>
</template>
<script>
import utils from '@/utils/pricing-utils'
export default {
  props: {
    price: {
      type: Number,
      default: 0
    },
    dsrp: {
      type: Boolean,
      default: false
    },
    viewInCart: { 
      type: Boolean,
      default: false
    }
  },
  computed: {
    priceString() {
      return utils.toDecimalPlaces(this.price, 2)
    }
  }
}
</script>